import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Loader from '../Utility/Loader/Loader';
import { DuplicateModalProps } from './types';
import { BombiixModal } from '../BombiixModal';
import { NewInput } from '../PIM/common';

const DuplicateModal: React.FC<DuplicateModalProps> = ({ onOpen, originalName, onConfirm, onCancel, loading = false, type }) => {
  const { t } = useTranslation(['custom-module-system-canvas', 'common']);
  const [itemName, setItemName] = useState('');
  const [error, setError] = useState('');
  const modalKey = `DUPLICATE_${type.toUpperCase()}_MODAL`;

  useEffect(() => {
    if (onOpen && originalName) {
      setItemName(`${t('DUPLICATE_MODAL.COPY_OF')} ${originalName}`);
      setError('');
    }
  }, [onOpen, originalName, t]);

  const handleConfirm = () => {
    if (!itemName.trim()) {
      setError(t(`${modalKey}.NAME_REQUIRED`));
      return;
    }

    if (itemName.trim().length < 3) {
      setError(t(`${modalKey}.NAME_TOO_SHORT`));
      return;
    }

    onConfirm(itemName.trim());
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !loading) {
      handleConfirm();
    }
  };

  return (
    <BombiixModal
      show={onOpen}
      title={t(`${modalKey}.TITLE`)}
      onClose={onCancel}
      hideSave
      size="md"
      footer={
        <button type="button" className="bombiix-btn btn-blue" onClick={handleConfirm} disabled={loading || !itemName.trim()}>
          {loading ? t(`${modalKey}.DUPLICATING`) : t('COMMON_LABEL.DUPLICATE', { ns: 'common' })}
        </button>
      }
    >
      {loading ? (
        <Loader />
      ) : (
        <>
          <NewInput
            id="itemName"
            label={t(`${modalKey}.${type.toUpperCase()}_NAME_LABEL`)}
            required
            invalid={!!error}
            value={itemName}
            onChange={(e) => {
              setItemName(e.target.value);
              if (error) setError('');
            }}
            onKeyDown={handleKeyDown}
            placeholder={t(`${modalKey}.${type.toUpperCase()}_NAME_PLACEHOLDER`)}
            autoFocus
          />
          {error && <div className="error-message">{error}</div>}
        </>
      )}
    </BombiixModal>
  );
};

export default DuplicateModal;
